<template>
    <div class="container">
        <div class="section">
            <img class="img" src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/test_engineer/pc/%E5%88%87%E7%89%87%402x.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220902/1662107029237.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220902/1662107068747.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220902/1662107111973.png">
        </div>
        <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220902/1662107155763.png">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220902/1662107310786.png">
        </div>
        <div class="section-main">
            <div class="_tb">
                <el-tabs v-model="activeName" @tab-click="changeTab">
                    <el-tab-pane class="main-tab" v-for="(item, index) in stageList" :key="index" :label="item.stage" :name="index">
                        <div class="region">
                            <div class="m-title"><div class="tx">{{item.title}}</div> <div v-if="item.details.length > 0" class="btn" @click="showModalFn(item)"></div></div>
                            <div class="m-icon"></div>
                            <div class="m-txt">
                                <div class="m-left">
                                    <div class="l-title">学习目标</div>
                                    <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" >{{v}}</div>
                                </div>
                                <div class="m-right">
                                    <div class="l-title">关键技术点</div>
                                    <div class="item" v-for="(v, i) in item.skillsList" :key="i" >{{v}}</div>
                                </div>
                            </div>
                        </div>

                    </el-tab-pane>
                </el-tabs>
                <button class="stage-more" @click="JumpFn('领取完整课程安排')">
                    <img src="https://s21.lgstatic.com/growth/activity/20210823/1629709678892.png">
                </button>
                <div class="tips-tab">
                    * 具体课程内容以实际课程安排和进度为准
                </div>
            </div>
            <div class="modal" v-if="showModal">
                <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                <div v-for="(item, index) in showData.details" :key="index">
                    <div class="modal-title">
                        {{item.t}}
                    </div>
                    <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                        {{i}}
                    </div>
                </div>
            </div>

        </div>
        <div class="section-sw">
            <div class="section-sw-title">名企实战项目案例</div>
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(item, index) in projectsDetail" :key="index" >
                        <div class="section-sw-content">
                            <div class="title">{{ item.title }}: {{ item.projectTitle }}</div>
                            <div class="inner">
                                <div class="item" v-for="(detail, k) in item.details" :key="k">
                                    <div class="item-title">{{ detail.title }}</div>
                                    <div class="item-txt">{{ detail.txt }}</div>
                                </div>
                                <img class="img" v-for="(img, j) in item.projectImgs" :key="j" :src="img" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
                <div class="swiper-button-next"></div>
                <div class="swiper-button-prev"></div>
            </div>
            <img class="section-btn" @click="JumpFn('获取更多项目资料')" src="https://s21.lgstatic.com/growth/activity/20220706/1657089016820.png" alt="">
        </div>
        <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220825/1661417938185.png">
        </div>
        <!-- <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220706/1657076523305.png">
            <div class="section-btn2" @click="JumpFn"></div>
        </div> -->
        <!-- <div class="section">
            <img class="img" src="https://s21.lgstatic.com/growth/activity/20220902/1662107198209.png">
        </div> -->
        <!-- <div class="section">
            <img class="img" src="https://s20.lgstatic.com/growth/activity/20220706/1657076560109.png">
        </div> -->
        <button class="footer" @click="JumpFn('名额有限立即抢占')">
            <img src="https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/test_engineer/pc/%E5%90%B8%E5%9C%B0%E6%8C%89%E9%92%AE%402x.png">
            <div class="iconBox" v-if="activity.isShow">
                <img class="icon" :src="activity.PCicon">
            </div>
        </button>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import activity from '../../../common/activity';
import List from './data.js'
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
export default {
    data() {
        return {
            activity,
            List,
            imgList:[],
            imgList1:[],
            imgList2:[],
            stageList:[],
            showData:[],
            pcSwiperList:[],
            showModal:false,
            activeName:0,
            projectsDetail: [],
            addressIdsMap: {
                "领取完整课程安排": "r1txg",
                "获取更多项目资料": "s1txh",
                "名额有限立即抢占": "t1txi"
            }
        }
    },
    mounted () {
        setTimeout(()=>{
            // this.eduPlatTrack('WebView', { page_id: '1qhg'});
            this.platTrack('pcpv', {
                page_id: 'k1tys',
            })
        },500)
        let dataList = this.List.data.pc;
        this.stageList = this.List.data.stageList
        this.projectsDetail = this.List.data.projectsDetail

        this.imgList = dataList.imgList
        this.imgList1 = dataList.imgList1
        this.imgList2 = dataList.imgList2
        this.pcSwiperList = dataList.pcSwiperList
        this.swiperInit()
    },
    methods: {
        JumpFn(str) {
            // this.eduPlatTrack('WebButtonClick', {
            //     'page_id': '1qhg',
            //     'button_name': '限时领取'
            // });
            str && this.platTrackClickFn(str);
            setTimeout(() => {
                handleJumpUrl(`0279ee5641134bdd9c792ccdf89d319f`);
            }, 200);
        },
        close() {
            this.showModal = false;
        },
        changeTab(val) {
            this.showModal = false
        },
        showModalFn(item) {
            this.showModal = true
            this.showData = item
        },
        swiperInit() {
            let option = {
                direction: 'horizontal',
                loop: true,
                speed: 800,
                autoplayDisableOnInteraction: false,
                autoplay: 3200,
                spaceBetween: 30,
                pagination: '.current1-pagination',
            };
            this.$nextTick(() => {
                const swiper1 = new Swiper('.current1-wrap', option);
            });
            let option1 = {
                loop: true,
                speed: 800,
                autoplayDisableOnInteraction: false,
                autoplay: 3200,
                pagination: '.swiper-pagination',
                paginationClickable: '.swiper-pagination',
                nextButton: '.swiper-button-next',
                prevButton: '.swiper-button-prev',
                spaceBetween: 30
            }
            setTimeout(() => {
                var swiper = new Swiper('.swiper-container', option1);
            }, 1000)

        },
        platTrackClickFn(name) {
            this.platTrack('pcclick', {
                page_id: 'k1tys',
                address_id: this.addressIdsMap[name]
            })
        },
        goAgreement() {
            window.location.href = "https://edu.lagou.com/growth/sem/doc4.html";
        }
    },
}
</script>

<style lang="less" scoped>
.container {
    width: 100%;
    background: #fff;
    padding-bottom: 150PX;
    .section {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        .section-btn2 {
            position: absolute;
            left: 50%;
            bottom: 30PX;
            width: 600PX;
            height: 120PX;
            transform: translateX(-50%);
        }
        .img {
            width: 100%;
            display: block;
        }
        .activityBox {
            position: absolute;
            top: 0;
            left: 50%;
            transform: translate(-50%);
            width: 950PX;
            height: 150PX;
        }
        .activityImg {
            display: block;
            float: right;
            width: 104PX;
            height: 133PX;
        }
        .btn1 {
            position: absolute;
            top: 10PX;
            left: 50%;
            transform: translate(-50%);
            width: 500PX;
            height: 100PX;
            z-index: 10;
            background-color:transparent;
            border: none;
        }
        .agreement {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 100%;
        }
    }
    .section-main {
        position: relative;
        width: 100%;
        min-width: 1200PX;
        padding: 1PX 0 80PX;
        background: #E6EDFF;
        ._tb {
            position: relative;
            margin: 15PX auto 0;
            width: 1000PX;
            background-color: #fff;
            box-shadow: 0PX 2PX 20PX 0PX rgba(83, 84, 124, 0.08);
            box-sizing: border-box;
            padding: 0PX 0PX 50PX;
            border-radius: 22px;
            /deep/ .el-tabs {
                width: 100%;

                .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll, .el-tabs__nav {
                    height: 86PX;
                    background: linear-gradient(322deg, #477EFF 0%, #3560E1 100%);
                    border-top-left-radius: 22PX;
                    border-top-right-radius: 22PX;
                }
                .el-tabs__nav {
                    background: transparent;
                }
                .el-tabs__item {
                    line-height: 86PX;
                    text-align: center;
                    width: 160PX;
                    height: 86PX;
                    padding: 0;
                    font-size: 24PX;
                    font-family: SourceHanSansSC-Bold, SourceHanSansSC;
                    font-weight: 400;
                    color: #fff;
                    margin: 0 8PX;
                    opacity: .8;
                }
                .el-tabs__nav-next, .el-tabs__nav-prev {
                    font-size: 28PX;
                    margin-top: 20PX;
                    color: #fff;
                }
                .el-tabs__nav-wrap.is-scrollable {
                    padding: 0 36PX;
                }
                .el-tabs__nav-wrap::after{
                    background-color: transparent;
                }
                .el-tabs__active-bar {
                    background-color: transparent;
                }
                .el-tabs__item.is-active {
                    font-weight: bold;
                    color: #fff;
                    opacity: 1;
                }
            }
            .region {
                width: 100%;
                box-sizing: border-box;
                padding: 20PX 40PX;
                .m-title {
                    width: 100%;
                    height: 30PX;
                    position: relative;
                    font-size: 24PX;
                    color: #303032;
                    text-align: center;
                    font-family: Helvetica;
                    font-weight: normal;
                    .tx {
                        position: absolute;
                        top: 0PX;
                        left: 50%;
                        transform: translate(-50%);
                    }
                    .btn {
                        float: right;
                        width: 90PX;
                        height: 30PX;
                        background: url('https://s21.lgstatic.com/growth/activity/20210325/1616656811847.png') no-repeat;
                        background-size: 100% 100%;
                        margin-right: 40PX;
                    }
                }
                .m-icon {
                    margin: 8PX auto;
                    width: 688PX;
                    height: 2PX;
                    background: url('https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png') no-repeat center;
                    background-size: 100% 100%;
                }
                .m-txt {
                    width: 100%;
                    // display: flex;
                    margin-top: 30PX;
                    .m-left {
                        // flex: 1;
                        box-sizing: border-box;
                        padding: 10PX 30PX;
                    }
                    .m-right {
                        // width: 360PX;
                        box-sizing: border-box;
                        padding: 10PX 30PX;
                    }
                    .l-title {
                        font-size: 16PX;
                        font-family: Helvetica;
                        color: #36363C;
                        position: relative;
                        padding-left: 14PX;
                        &::before{
                            content: '';
                            width: 6PX;
                            height: 22PX;
                            background: linear-gradient(322deg, #477EFF 0%, #3560E1 100%);
                            position: absolute;
                            left: 0PX;
                            top: 50%;
                            transform: translateY(-50%);
                        }
                    }
                    .item {
                        position: relative;
                        font-size: 14PX;
                        font-family: Helvetica;
                        color: #49494B;
                        padding-left: 15PX;
                        margin: 14PX 0;
                        &::after {
                            position: absolute;
                            content: '';
                            left: 0PX;
                            top: 8PX;
                            width: 4PX;
                            height: 4PX;
                            border-radius: 50%;
                            background: #959DFF;
                        }
                    }
                }
            }
            .tips-tab {
                font-size: 14PX;
                color: #666;
                position: absolute;
                bottom: 80PX;
                right: 40PX;
            }
            .stage-more {
                position: absolute;
                bottom: -54PX;
                left: 50%;
                transform: translate(-50%);
                width: 448PX;
                background-color:transparent;
                border: none;
                z-index: 9;
                img {
                    width: 100%;
                    display: block;
                }
            }

        }
        .modal {
            position: absolute;
            top: 180PX;
            left: 50%;
            transform: translate(-50%);
            width: 800PX;
            border-radius: 16PX;
            background-color: #fefefe;
            z-index: 999;
            border: 2PX solid #6469A7;
            box-sizing: border-box;
            padding: 20PX 50PX 40PX;
            .close {
                position: absolute;
                right: 14PX;
                top: 14PX;
                width: 40PX;
                height: 40PX;
            }
            .modal-title {
                font-size: 20PX;
                padding:35PX 0 10PX;
                color: #6469A7;
            }
            .modal-desc {
                font-size: 14PX;
                color: #6469A7;
                padding-left: 18PX;
            }
        }

    }

    .section-swmain {
        /deep/ .current1-wrap {
            width: 900PX;
            height: 860PX;
            margin: 0PX auto;
            .swiper-slide {
                width: 900PX;
                img {
                    width: 100%;
                }
            }
            .swiper-pagination {
                bottom: 0PX;
            }
            .swiper-pagination-bullet{
                width: 10PX;
                height: 10PX;
                background: linear-gradient(181deg, #3560E1 0%, #477EFF 100%);
                border-radius: 50%;
                opacity: .4;
                &-active{
                    border-radius: 10PX;
                    width: 28PX;
                    background: linear-gradient(181deg, #3560E1 0%, #477EFF 100%);
                    opacity: 1;
                }
            }
        }
    }

    .footer {
        position: fixed;
        background-color:transparent;
        border: none;
        bottom: -1PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 999;
        width: 100%;
        box-shadow: 0PX -12PX 12PX 0PX rgba(156, 157, 185, 0.22);
        img {
            width: 100%;
            display: block;
        }
        .iconBox {
            position: absolute;
            top: -30PX;
            left: 50%;
            transform: translate(-50%);
            z-index: 9999;
            width: 940PX;
            .icon {
                float: right;
                width: 134PX;
            }
        }
    }
}
/deep/ .section-sw {
    position: relative;
    width: 100%;
    min-width: 1200PX;
    background-color: #fff;
    overflow: hidden;
    padding-bottom: 20PX;
    .section-sw-title {
        font-family: SourceHanSansCN-Medium;
        font-weight: 500;
        font-size: 40PX;
        background-image: linear-gradient(126deg, #0029A1  5%, #225CE5 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        letter-spacing: 0;
        text-align: center;
        line-height: 36PX;
        margin-top: 90PX;
    }
    .section-sw-content {
        width: 1079PX;
        background-image: radial-gradient(circle at 96% 97%, #477EFF 0%, #3560E1 153%);
        box-shadow: 0 2px 15px 0 rgba(225,225,225,0.73);
        border-radius: 22px;
        margin: 40PX auto 0;
        padding-bottom: 50PX;
        .title {
            height: 80PX;
            line-height: 80PX;
            padding-left: 60PX;
            font-family: SourceHanSansCN-Medium;
            font-weight: 500;
            font-size: 34PX;
            color: #FFFFFF;
        }
        .inner {
            width: 1053PX;
            background-color: #fff;
            border-radius: 22px;
            margin: 0 auto;
            padding: 10PX 80PX 60PX 50PX;
            box-sizing: border-box;
            .item {
                margin-top: 30PX;
                .item-title {
                    width: 157PX;
                    height: 41PX;
                    line-height: 41PX;
                    background-image: radial-gradient(circle at 94% 91%, #FF8A00 0%, #E30000 121%);
                    border-radius: 20PX;
                    text-align: center;
                    font-family: SourceHanSansCN-Medium;
                    font-weight: 500;
                    font-size: 26PX;
                    color: #FFFFFF;
                }
                .item-txt {
                    position: relative;
                    opacity: 0.7;
                    font-family: SourceHanSansCN-Regular;
                    font-weight: 400;
                    font-size: 24PX;
                    color: #595959;
                    padding-left: 16PX;
                    box-sizing: border-box;
                    margin-top: 16PX;
                    &::before {
                        content: "";
                        position: absolute;
                        left: 0;
                        top: 16PX;
                        width: 8PX;
                        height: 8PX;
                        background: #959DFF;
                        border-radius: 4PX;
                    }
                }
            }
            .img {
                display: block;
                width: 721PX;
                margin: 20PX auto 0;
            }
        }
    }
    .swiper-container {
        width: 1250PX;
        height: 1300PX;
    }
    .swiper-container-horizontal > .swiper-pagination-bullets {
        bottom: 50PX;
    }
    .swiper-pagination-bullet{
        width: 10PX;
        height: 10PX;
        background-image: linear-gradient(126deg, #4378F9 5%, #92B2FF 100%);
        border-radius: 50%;
        opacity: .5;
        &-active{
            opacity: 1;
            border-radius: 10PX;
            width: 22PX;
            background-image: linear-gradient(126deg, #4378F9 5%, #92B2FF 100%);
        }
    }
    .swiper-button-prev {
        background: url('https://s21.lgstatic.com/growth/activity/20220706/1657088312847.png') no-repeat center;
        background-size: 100% 100%;
        width: 58PX;
        height: 58PX;
        top: 50%;
        transform: translateY(-50%);
        left: 0PX;
    }
    .swiper-button-next {
        background: url('https://s21.lgstatic.com/growth/activity/20220706/1657088297886.png') no-repeat center;
        background-size: 100% 100%;
        width: 58PX;
        height: 58PX;
        right: -80PX;
        top: 50%;
        transform: translateY(-50%);
        right: 0PX;
    }
    .section-btn {
        width: 540PX;
        height: 128PX;
        display: block;
        margin: 0 auto;
    }
}
</style>
